import { FieldPermissionGroupDto } from "../data/service-proxies";

export type ProLogsPermissions = {
  actionPermissions?: { [name: string]: boolean };
  fieldPermissions?: FieldPermissionGroupDto[];
};

export type ProtectedEntityDtos = {
  view?: string;
  list?: string;
  create?: string;
  edit?: string;
};

export type ProtectedEntity = { entityName: string; dtos: ProtectedEntityDtos };
type ProtectedEntities = {
  Company: ProtectedEntity;
  EldDevice: ProtectedEntity;
  DvirForm: ProtectedEntity;
  Group: ProtectedEntity;
  NotificationSubscription: ProtectedEntity;
  Trailer: ProtectedEntity;
  Driver: ProtectedEntity;
  FleetManager: ProtectedEntity;
  Vehicle: ProtectedEntity;
  MasterFleetManager: ProtectedEntity;
  MasterEldDevice: ProtectedEntity;
};

export const protectedEntities: ProtectedEntities = {
  Company: {
    entityName: "Company",
    dtos: {
      view: "CompanyDto",
      list: "CompanyListDto",
      create: "CreateCompanyDto",
      edit: "UpdateCompanyDto",
    },
  },
  EldDevice: {
    entityName: "EldDevice",
    dtos: {
      create: "CreateEldDeviceDto",
      list: "EldDeviceListDto",
      edit: "UpdateEldDeviceDto",
    },
  },
  DvirForm: {
    entityName: "DvirForm",
    dtos: {
      edit: "UpdateDvirFormDto",
    },
  },
  Group: {
    entityName: "Group",
    dtos: {
      create: "CreateUpdateGroupDto",
      edit: "CreateUpdateGroupDto",
      list: "GroupListDto",
    },
  },
  NotificationSubscription: {
    entityName: "NotificationSubscription",
    dtos: {
      create: "NotificationSubscriptionDto",
      edit: "NotificationSubscriptionDto",
      list: "NotificationSubscriptionListDto",
    },
  },
  Trailer: {
    entityName: "Trailer",
    dtos: {
      create: "CreateTrailerDto",
      list: "TrailerListDto",
      edit: "UpdateTrailerDto",
    },
  },
  Driver: {
    entityName: "Driver",
    dtos: {
      create: "CreateDriverDto",
      list: "DriverListDto",
      edit: "UpdateDriverDto",
    },
  },
  FleetManager: {
    entityName: "FleetManager",
    dtos: {
      create: "CreateFleetManagerDto",
      list: "FleetManagerListDto",
      edit: "UpdateFleetManagerDto",
    },
  },
  Vehicle: {
    entityName: "Vehicle",
    dtos: {
      create: "CreateVehicleDto",
      edit: "UpdateVehicleDto",
      list: "VehicleListDto",
    },
  },
  MasterFleetManager: {
    entityName: "MasterFleetManager",
    dtos: {
      edit: "UpdateMasterFleetManagerDto",
    },
  },
  MasterEldDevice: {
    entityName: "MasterEldDevice",
    dtos: {
      edit: "MasterEldDeviceDto",
    },
  },
};
